// @flow
import { signPayload } from '../crypto';

export const signRequest = (secret: string, path: string, payload: string = '') =>
  signPayload(secret, `${path.startsWith('/') ? '' : '/'}${path}:${payload}`);
